import makeCrud from '../crud';
import httpReq from '../request';

const REWARD = 'reward';
const crud = new makeCrud(REWARD);

var config = {
    "headers": {
        "Authorization": "Basic " + localStorage.getItem('token')
    }
};

const index = {
    save: (data) => {
        return crud.save(data)
    },
    update: (data) => {
        return crud.update(data)
    },
    delete: (id) => {
        return crud.delete(id)
    },
    findById: (id) => {
        return crud.findById(id)
    },
    findByUserIdAndKey: async (key) => {
        var user = JSON.parse(localStorage.getItem("user"));
        return (await httpReq.get('/api/reward/search/findByUserIdAndKey?userId=' + user.id + '&key=' + key, config));
    },
}

export default index;